/* eslint-disable complexity */
import { ApiClientConstant, Table } from '@cureskin/api-client'
import { ChangeDetectorRef, Component, effect, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BroadcastService } from '@services/broadcast-service';
import { ConnectionService } from '@services/connection-service';
import { PopUpModalType } from '@components/pop-up-modal/pop-up-modal.type';
import { EventLoggerService } from '@services/event-logger-service';
import { AppWebBridgeService } from '@services/app-web-bridge-service';
import { WindowRefService } from '@services/window-ref-service';
import { DeliveryDateService } from '@services/delivery-date-service/delivery-date.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CannotCancelOrderComponent } from '@shared/bottom-sheet-layouts/cannot-cancel-order/cannot-cancel-order.component';
import { CancelOrderComponent } from '@shared/bottom-sheet-layouts/cancel-order/cancel-order.component';
import { OrderConsultationLog, RefundInfoObject } from '@cureskin/api-client/src/server-api';
import { AppConfig } from '../../app.config';
import { OrderService } from '@services/order-service/order.service';
import {
  MoneyBackGuaranteeBottomsheetComponent
} from '@shared/bottom-sheet-layouts/money-back-guarentee-bottomsheet/money-back-guarantee-bottomsheet.component';
import { PRIMARY_CHANNELS } from '@services/event-logger-service/event-logger.constant';
import { CartService } from '@services/cart-service/cart.service';
import { UserService } from '@services/user/user.service';
import { Store } from '@ngrx/store';
import * as fromSelectors from '@store/selectors/app.selectors';
import * as fromActions from '@store/actions/app.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'user-order-view',
  templateUrl: './user-order-view.html',
  styleUrls: ['./user-order-view.scss'],
  standalone: false,
})
export class UserOrderViewComponent {
  REQUEST_CODE: any = { REGIMEN_ORDER_CANCEL: 1, ORDER_CANCEL: 2, ORDER_CANCEL_REASON: 3 };
  approvedByDoctor: string;
  allLocalStages: Array<any>;
  cancelOrderAllowed: boolean;
  changeAddressAllowed: boolean;
  order: any;
  orderStages: Array<any> = [];
  user: any;
  doctor: any;
  isHideMedicine: boolean = false;
  productInfo: Array<any> = [];
  expectedDeliveryDate: { from?: Date, to?: Date } = {};
  popUpModal: PopUpModalType.ConfigParams = { open: false };
  regimenApproved: boolean = false;
  products: any = {};
  orderSp: any = 0;
  orderMRP: any = 0;
  orderId: string;
  deliveryIntervalInDays: number = 2;
  isEnglishOrHindiUser: boolean = false;

  orderPaymentPendingStages: any[] = [...this.appConfig.Shared.Order.Stage.orderPaymentPendingStages];
  orderPlacedStages: any[] = [...this.appConfig.Shared.Order.Stage.orderPlacedStages];
  orderPackedStages: any[] = [...this.appConfig.Shared.Order.Stage.orderPackedStages];
  orderDispatchedStages: any[] = [...this.appConfig.Shared.Order.Stage.orderDispatchedStages];
  orderDeliveryFailedStages: any[] = [...this.appConfig.Shared.Order.Stage.orderDeliveryFailedStages];
  orderOutForDeliveryStages: any[] = [...this.appConfig.Shared.Order.Stage.orderOutForDeliveryStages];
  orderDeliveredStages: any[] = [...this.appConfig.Shared.Order.Stage.orderDeliveredStages];
  orderCanceledStages: any[] = [...this.appConfig.Shared.Order.Stage.orderCanceledStages];
  isiOSDevice: boolean = false;
  regimens: any;
  orderPayments: Table.Payment[] = [];
  totalTransactionAmount: number = 0;
  totalCumulativeQuantityOfProducts: number = 0;
  newCancellationLogicExperiment: boolean = false;
  showOrderCannotBeCancelledPopUp: boolean = false;
  orderNumber: string = '';
  orderType: string = '';
  orderStage: string = this.appConfig.Shared.Order.Stage.INITIAL;
  regimen: any;
  bgColor: string;
  loading: boolean = false;
  freeProducts: Array<Record<string, unknown>> = [];
  regimenClassText: string = this.appConfig.Shared.RegimenFor.SKIN;
  isRegimenOrder: boolean = true;
  isRegimenPresent: boolean = true;
  orderStagesToShowCannotCancelPopup: Array<string> = [];
  showKnowHowToUseProductsCTA: boolean = true;
  latestOrderLog: OrderConsultationLog;
  isOrderInRefundRelatedStages: boolean = false;
  refundProcessedDate: Date = null;
  productsCount: number = 4;
  productApprovalDetails: any;
  cancelledProducts: Array<Table.Order['attributes']['productApprovalDetails']['productDetails'][number]>;
  refundInfo: RefundInfoObject;
  isOnlinePayment: boolean;
  shouldShowPartialOrderCancellationUI: boolean = false;
  userOrder = signal<any>({});
  internalUser: boolean = false;
  shouldHideProductDetails: boolean = false;
  availableFreeProductsFromExperiment: string[] = [];
  orderStatusBannerExp: boolean = false;
  productsInCart: { [key: string]: number } = {};
  numberOfProductsInCart: number = 0;
  cartItems: any[] = [];
  isAddingToCart: boolean = false;
  private hasOthersInstructions: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly broadcast: BroadcastService,
    private readonly route: ActivatedRoute,
    private readonly conn: ConnectionService,
    public readonly appConfig: AppConfig,
    private readonly eventLogger: EventLoggerService,
    private readonly router: Router,
    private readonly appWebBridge: AppWebBridgeService,
    private readonly windowRef: WindowRefService,
    public readonly deliveryDateService: DeliveryDateService,
    private readonly bottomSheet: MatBottomSheet,
    private readonly changeDetectionRef: ChangeDetectorRef,
    private readonly orderService: OrderService,
    private readonly cartService: CartService,
    private readonly store: Store,
    private readonly userService: UserService,
  ) {
    effect(() => {
      const order = this.userOrder();
      if (order) {
        this.setProductApprovalData();
      }
    });
    this.subscriptions.push(
      this.store.select(fromSelectors.selectCartProducts).subscribe((products: { [key: string]: number }) => {
        this.productsInCart = { ...products };
        this.numberOfProductsInCart = Object.values(products).reduce((total: number, quantity: number) => {
          return total + (Number(quantity) || 0);
        }, 0);
      })
    );
    this.subscriptions.push(
      this.broadcast.on('REFRESH_SHOP_CART').subscribe((): void => {
        void this.refreshCart();
      }),
    );
  }

  async ngOnInit(): Promise<any> {
    this.loading = true;
    this.user = await this.conn.getActingUser();
    this.getUserLanguagePreference();
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'user-order-view' }), PRIMARY_CHANNELS);
    this.setUserExperiments();
    this.internalUser = this.conn.isInternalUser();
    this.orderCanceledStages = this.orderCanceledStages.filter(
      (stage: string): boolean => !this.appConfig.Shared.Order.Stage.orderRefundStages.includes(stage));
    this.orderId = this.route.snapshot.params?.id;
    this.order = await this.conn.findOrderWithSignedURL(this.orderId);
    this.userOrder.set(this.order);
    this.productsCount = this.order?.get('regimenStateAtLastCheckpoint')?.get('products')?.length || this.order?.get('regimen')?.get('products')?.length || 4;
    this.checkForRefundStatus();
    this.isRegimenOrder = this.order?.get('type') === this.appConfig.Shared.Order.Type.REGIMEN;
    this.isRegimenPresent = !!(this.order?.get('regimenStateAtLastCheckpoint') || this.order?.get('regimen'));
    if (this.user?.get('allocatedDoctor')) this.doctor = await this.conn.findUserByObjectId(this.user?.get('allocatedDoctor')?.id);
    this.orderType = this.order?.get('type');
    this.orderNumber = this.order?.get('orderNumber');
    this.regimen = this.order?.get('regimenStateAtLastCheckpoint') || this.order?.get('regimen');
    this.isOnlinePayment = this.order.get('paymentType') === this.appConfig.Shared.Order.PaymentType.ONLINE;
    this.showKnowHowToUseProductsCTA = !!(this.order?.get('regimen')?.get('regimenId'));
    await this.checkOthersInstructionsAvailability();
    this.orderPayments = await this.conn.findSuccessfulNonCODOrderPayments(this.order);
    this.updateOrderAmountForCOD();
    this.updateBgColor();
    this.orderSp = this.order.get('amount') - (this.order.get('paidAmount') || 0);
    if (!this.regimen) {
      this.orderMRP = this.order.get('actualPrice');
    }
    if (this.regimen) {
      const regimen = JSON.parse(JSON.stringify(this.regimen));
      this.orderMRP = Math.round(regimen.fixedPriceMRP);
      regimen.totalMRP = Math.round(regimen.fixedPriceMRP);
      regimen.totalSP = regimen?.fixedPrice;
      regimen.discount = Math.floor(((regimen.totalMRP - regimen.totalSP) * 100) / regimen.totalMRP);
    }
    // If order is in initial stage, ie products are not copied from regimen to
    // products array. Then we need to pick products from `regimen.products`.
    // Also we need to hide `repair` products name to prevent users from finding those
    // products and leading to order cancellation.
    if (!this.order?.get('products')?.length && this.regimen) {
      await Promise.all(this.regimen?.get('products')
        .map((product: any): Promise<any> => product.fetch()));
      this.products = this.regimen?.get('products')
        ?.reduce((acc: any, product: any): any => ({ ...acc, [product.id]: product }), {});

      if (this.order?.get('regimenStateAtLastCheckpoint')?.get('extraProducts')?.length) {
        await Promise.all(this.regimen?.get('extraProducts')
          .map((product: any): Promise<any> => product.fetch()));
        const extraProducts = this.regimen?.get('extraProducts')
          ?.reduce((acc: any, product: any): any => ({ ...acc, [product.id]: product }), {});
        if (extraProducts) this.products = { ...this.products, ...extraProducts };
      }
      // Remove this unnecessary experiments call
      const experiments = await this.conn.findUserActiveExperiments();
      const isHideMedicine = experiments?.find((experiment: any): any => experiment.key === 'hide_prescription_medicines');
      // Rename repair products name untill it's delivered
      if (isHideMedicine && this.order?.get('stage') !== this.appConfig.Shared.Order.Stage.DELIVERED) {
        Object.values(this.products).forEach((product: any): void => {
          if (product?.get('purpose') && product?.get('purpose').toLowerCase().includes('repair')) {
            product.set('title', `${product?.get('purpose')} product`);
          }
        });
      }
    } else {
      this.products = this.order?.get('products')?.reduce((acc: any, product: any): any => ({ ...acc, [product.id]: product }), {});
    }

    await this.getFreeProductDetails();

    if (this.doctor
      && this.doctor?.get('DoctorDisplayName')
      && this.order?.get('type') === this.appConfig.Shared.Order.Type.REGIMEN
      && [...this.appConfig.Shared.Order.Stage.AfterShipment, this.appConfig.Shared.Order.Stage.DELIVERED]
        .includes(this.order?.get('stage'))
    ) this.regimenApproved = true;
    await this.findOrderStages();

    const currentStage = this.order.get('stage');
    const isEligibleStage: boolean = [
      ...this.orderPlacedStages,
      ...this.orderPackedStages,
      ...this.orderDispatchedStages,
    ].includes(currentStage);

    if (isEligibleStage) await this.setDeliveryDate();

    this.setRegimenClassText();
    this.loading = false;

    this.isiOSDevice = (await this.appWebBridge.requestOSInformation()) === 'iOS' || this.windowRef?.isSafariBrowser();
    this.getTotalCumulativeQuantityOfProducts();
    this.setProductApprovalData();
    await this.fetchCancelledProductsCatalogData();
    await this.setRefundDetailsForOrder();
    await this.refreshCart();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  updateBgColor(): void {
    this.bgColor = this.setBgColorBasedOnOrderStage();
  }

  async setDeliveryDate(): Promise<void> {
    // If user language is not english or hindi, then we show the static delivery date
    if (!this.isEnglishOrHindiUser) {
      this.expectedDeliveryDate = this.deliveryDateService.calculateExpectedDeliveryDate(null, this.deliveryIntervalInDays);
      return;
    }
    try {
      const res = await this.conn.getExpectedDeliveryDateByOrderId(this.orderId);
      const responseDateISO = res?.expectedDeliveryDate;
      this.expectedDeliveryDate = this.deliveryDateService.calculateExpectedDeliveryDate(
        responseDateISO,
        this.deliveryIntervalInDays,
      );
    } catch (error) {
      this.expectedDeliveryDate = this.deliveryDateService.calculateExpectedDeliveryDate(
        new Date().toISOString(),
        this.deliveryIntervalInDays,
      );
    }
  }

  async updateOrderAmountForCOD(): Promise<void> {
    this.totalTransactionAmount = this.orderPayments?.reduce((total: number, payment: Table.Payment): number => {
      const transactionAmount = Number(payment?.get('TransactionAmount') || 0) / 100;
      return total + transactionAmount;
    }, 0);
    if (this.order.get('paymentType') === this.appConfig.Shared.Order.PaymentType.COD) {
      this.order.set('amount', this.order.get('amount') - this.totalTransactionAmount);
    }
  }

  async cancelOrderDialog(): Promise<any> {
    if ((this.newCancellationLogicExperiment && this.showOrderCannotBeCancelledPopUp
      && this.order?.get('type') === this.appConfig.Shared.Order.Type.REGIMEN)) {
      this.bottomSheet.open(CannotCancelOrderComponent, {
        data: {},
      });
      return;
    }
    if ((this.newCancellationLogicExperiment && !this.showOrderCannotBeCancelledPopUp)
    ) {
      this.bottomSheet.open(CancelOrderComponent, {
        data: {
          callback: (cancelReason: string): void => {
            this.cancelOrder(cancelReason);
            this.bottomSheet.dismiss();
          },
        },
        backdropClass: 'bottomsheet-blur-overlay-sm',
      });
      return;
    }
    if (this.order?.get('type') === this.appConfig.Shared.Order.Type.REGIMEN) {
      this.popUpModal = {
        open: true,
        title: this.appConfig.Shared.String.GOT_QUESTIONS,
        type: this.appConfig.Dialog.CONFIRMATION,
        requestCode: this.REQUEST_CODE.REGIMEN_ORDER_CANCEL,
        cancelText: this.appConfig.Shared.String.SEE_REVIEWS,
        okText: this.appConfig.Shared.String.CANCEL_ORDER,
        message: { type: this.appConfig.Shared.String.CANCEL_ORDER_OFFER_CONFIRM },
      };
      return;
    }
    this.popUpModal = {
      requestCode: this.REQUEST_CODE.ORDER_CANCEL,
      type: this.appConfig.Dialog.CONFIRMATION,
      cancelText: this.appConfig.Shared.String.SEND_PRODUCTS,
      title: this.appConfig.Shared.String.CANCEL_ORDER,
      okText: this.appConfig.Shared.String.CANCEL_ORDER,
      message: { type: this.appConfig.Shared.String.CANCEL_ORDER_OFFER_CONFIRM },
      open: true,
    };
  }

  cancelOrder(cancelReason?: string): void {
    this.broadcast.broadcast('LOADING', { status: true });
    this.conn.cancelOrder(this.order.id, cancelReason)
      .then((): void => this.order.fetch())
      .then((order: any): void => {
        this.order = order;
        this.broadcast.broadcast('LOADING', { status: false });
        this.findOrderStages();
        if (!order?.get('cancelReason')) {
          this.popUpModal = {
            open: true,
            title: this.appConfig.Shared.String.CANCEL_ORDER,
            requestCode: this.REQUEST_CODE.ORDER_CANCEL_REASON,
            type: this.appConfig.Dialog.RADIO_BUTTON,
            okText: this.appConfig.Shared.String.SUBMIT,
            inputs: [
              { text: this.appConfig.Shared.String.WILL_ORDER_LATER },
              { text: this.appConfig.Shared.String.REGIMEN_NOT_HAPPY },
              { text: this.appConfig.Shared.String.ORDER_MISTAKE },
              { text: this.appConfig.Shared.String.COSTLY },
              { text: this.appConfig.Shared.String.SOMETHING_ELSE },
            ],
            message: { type: this.appConfig.Shared.String.ORDER_CANCEL_REASON },
          };
          return;
        }
        this.broadcast.broadcast('NOTIFY', { message: 'Order cancelled successfully' });
      })
      .catch((err: any): void => {
        this.broadcast.broadcast('LOADING', { status: false });
        this.popUpModal = {
          title: this.appConfig.Shared.String.CANCEL_ORDER,
          open: true,
          cancelText: this.appConfig.Shared.String.OK,
          type: this.appConfig.Dialog.ALERT,
          message: { text: err.message },
        };
      })
      .finally((): void => {
        this.updateBgColor();
        this.updateOrderFlags();
        this.changeDetectionRef.detectChanges();
      });
  }

  onPopUpClose(result: PopUpModalType.Result): void {
    this.popUpModal.open = false;
    switch (result.requestCode) {
      case this.REQUEST_CODE.ORDER_CANCEL: {
        if (result.clickOnYes) this.cancelOrder();
        break;
      }
      case this.REQUEST_CODE.ORDER_CANCEL_REASON: {
        this.cancelOrder(result?.input?.text);
        break;
      }
      case this.REQUEST_CODE.REGIMEN_ORDER_CANCEL: {
        if (result.clickOnYes) {
          this.cancelOrder();
          return;
        }
        if (result.clickOnNo) {
          setTimeout((): Promise<any> => this.router.navigate(['/user/testimonialsNew']), 200);
        }
        break;
      }
      default:
    }
  }

  makePaymentForOrder(): void {
    this.router.navigate(['./payment'], { relativeTo: this.route });
  }

  updateOrderFlags(): void {
    this.cancelOrderAllowed = false;
    this.changeAddressAllowed = false;
    if ([
      this.appConfig.Shared.Order.Stage.CANCELED,
      this.appConfig.Shared.Order.Stage.REFUND_REQUESTED,
    ].includes(this.order?.get('stage'))) {
      this.cancelOrderAllowed = false;
      return;
    }

    if (this.appConfig.Shared.Order.Stage.BeforeShipment.includes(this.order?.get('stage'))) this.changeAddressAllowed = true;
    const currentOrderStage: any = this.allLocalStages?.find((stage: any): boolean => stage.name === this.order?.get('stage'));
    if (currentOrderStage) {
      if (this.newCancellationLogicExperiment && this.order?.get('type') === this.appConfig.Shared.Order.Type.REGIMEN) {
        const orderCannotBeCancelledStages = [...this.orderStagesToShowCannotCancelPopup];
        const isOrderCanBeCancelled = currentOrderStage
          .possibleStageChange.some(({ name }: { name: string }): boolean => (this.appConfig.Shared.Order.Stage.CANCELED === name));

        if (orderCannotBeCancelledStages.includes(this.order.get('stage'))) {
          this.cancelOrderAllowed = true;
          this.showOrderCannotBeCancelledPopUp = true;
        } else if (isOrderCanBeCancelled) {
          this.cancelOrderAllowed = true;
        }
      } else {
        this.cancelOrderAllowed = currentOrderStage
          .possibleStageChange.some(({ name }: { name: string }): boolean => (this.appConfig.Shared.Order.Stage.CANCELED === name));
      }
    }
  }

  async findOrderStages(): Promise<void> {
    this.orderStages = [];
    this.allLocalStages = await this.conn.fetchOrderStages();
    this.updateOrderFlags();
    const orderStages: any[] = (await this.conn.findOrderStages({ order: this.order }, ['createdBy']))?.reverse();
    orderStages?.forEach((orderStage: any): void => {
      const orderStageJson = this.allLocalStages.find((stage: any): boolean => stage.name === orderStage?.get('stage'));
      if (orderStage?.get('stage') === this.appConfig.Shared.Order.Stage.DR_VERIFIED) {
        this.approvedByDoctor = orderStage?.get('createdBy')?.get('DoctorDisplayName');
      }
      orderStage.set('orderStage', orderStageJson);
      if (orderStageJson && orderStageJson.visibleToUser !== false) this.orderStages.push(orderStage);
    });
  }

  async reorder(product: any, imgElement?: HTMLImageElement): Promise<void> {
    if (this.isAddingToCart) return;
    this.isAddingToCart = true;
    try {
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'reorder-add-to-cart' }));
      const catalogProduct = this.products[product.id];
      const productData = catalogProduct ? JSON.parse(JSON.stringify(catalogProduct)) : { objectId: product.id };

      const result = await this.cartService.addOrRemoveFromCart(
        productData,
        this.appConfig.Shared.Cart.Action.ADD,
        {
          productsInCart: this.productsInCart,
          cartItems: this.cartItems,
          img: imgElement,
          section: 'reorderFromOrderDetails',
        }
      );

      if (result.success) {
        this.productsInCart = result.updatedProductsInCart;
        await this.refreshCart();
      }
    } finally {
      this.isAddingToCart = false;
    }
  }

  private async refreshCart(): Promise<void> {
    const cart = await this.conn.getCart();
    this.cartItems = cart?.get('lineItems') || [];
    const cartProductQuantities: { [key: string]: number } = {};
    this.cartItems.forEach((item: any) => {
      cartProductQuantities[item.productId] = item.quantity;
    });
    this.store.dispatch(fromActions.CartUpdateProductsBegin({ products: cartProductQuantities }));
  }

  trackOrder(url: string): void {
    if (this.isiOSDevice) this.conn.navigateToURL(url);
    else this.broadcast.broadcast('OPEN_IN_NEW_TAB', { url });
  }

  openInvoiceUrl(url: string): void {
    if (this.isiOSDevice) this.conn.navigateToURL(url);
    else this.broadcast.broadcast('OPEN_IN_NEW_TAB', { url });
  }

  openURL(url: string): void {
    this.conn.navigateToURL(url);
  }

  viewProductDetail(product: any): void {
    if (this.isBlockedForUnpaidAcquisitionProduct()) return;
    this.conn.navigateToURL(`/product/${product.id}`);
  }

  isBlockedForUnpaidAcquisitionProduct(): boolean {
    return this.userService.isUnpaidUser(this.user)
      && this.order?.get('type') === ApiClientConstant.Order.Type.PRODUCT;
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  seeInstructions(): void {
    this.router.navigate(['/user'], {
      queryParams: { tab: 'regimen', class: this.resolveInstructionClass(), init: 'true' },
      replaceUrl: true,
    });
  }

  async checkOthersInstructionsAvailability(): Promise<void> {
    if (this.user?.get('orderState') !== this.appConfig.Shared.User.OrderState.DELIVERED) {
      this.hasOthersInstructions = false;
      return;
    }
    const userInstructions = await this.conn.getInstructionsForUser();
    this.hasOthersInstructions = (userInstructions?.userInstructions?.ADDITIONAL_PRODUCTS?.length ?? 0) > 0;
  }

  private resolveInstructionClass(): string {
    const FACE = this.appConfig.Shared.Regimen.Class.FACE;
    const HAIR = this.appConfig.Shared.Regimen.Class.HAIR;
    const orderClass = this.regimen?.get('class');
    if (orderClass === FACE) return FACE;
    if (orderClass === HAIR) return HAIR;
    if (this.hasOthersInstructions) return 'OTHERS';
    return FACE;
  }

  handleNavigation(product:any): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'view_product_order_page' }));
    if (this.isBlockedForUnpaidAcquisitionProduct()) return;
    this.conn.navigateToURL(`/product/${product.id}`);
  }

  getTotalCumulativeQuantityOfProducts(): void {
    this.totalCumulativeQuantityOfProducts = this.order?.get('productInfo')?.reduce(
      (total: number, product: any): number => total + product.quantity, 0);
  }

  setBgColorBasedOnOrderStage(): string {
    const isOrderInCancelledStages = this.orderCanceledStages.includes(this.order?.get('stage'));
    this.appWebBridge.setStatusBarColor(isOrderInCancelledStages ? 'orange/accentLight' : 'cure/accentLight');
    return isOrderInCancelledStages ? 'tw-bg-orange-100' : 'tw-bg-teal-100';
  }

  async navigateToRegimenPage(): Promise<void> {
    await this.router.navigate(['/user'], {
      queryParams: { tab: 'regimen', class: this.resolveInstructionClass() },
      replaceUrl: true,
    });
  }

  async getFreeProductDetails(): Promise<void> {
    const isRegimenOrder = this.order?.get('type') === ApiClientConstant.Order.Type.REGIMEN;
    const regimenExtraProducts = (this.order?.get('regimenStateAtLastCheckpoint')?.get('extraProducts')
      || this.order?.get('regimen')?.get('extraProducts'));
    if (!regimenExtraProducts || !isRegimenOrder) return;
    await Promise.all(regimenExtraProducts?.map((extraProduct: any): any => extraProduct.fetch()));
    const freeProducts = this.order?.get('productInfo')?.filter((product: any): boolean => {
      if (product.SP !== 0) return false;
      const hasFreeProductsInExperimentVariant = this.availableFreeProductsFromExperiment?.length > 0;
      return hasFreeProductsInExperimentVariant && this.availableFreeProductsFromExperiment.includes(product.id);
    });

    const freeProductsWithImgUrl = freeProducts?.map((freeProduct: any): any => {
      const matchingExtraProduct = regimenExtraProducts?.find(
        (extraProduct: any):boolean => extraProduct.id === freeProduct.id);

      if (matchingExtraProduct) {
        return {
          ...freeProduct,
          imgUrl: matchingExtraProduct?.get('rebrandedImageWithoutBackground')?.[0],
        };
      }
      return freeProduct;
    });

    this.freeProducts = [...freeProductsWithImgUrl];
  }

  setRegimenClassText(): void {
    this.regimenClassText = (this.regimen?.get('class')
    === this.appConfig.Shared.InstantCheckup.Type.FACE) ? this.appConfig.Shared.RegimenFor.SKIN.toLowerCase()
      : this.regimen?.get('class').toLowerCase();
  }

  navigateToShoPage(): void {
    this.router.navigate(['/user'], { queryParams: { tab: 'shop', back: 'home' } });
  }

  async checkForRefundStatus(): Promise<void> {
    if (this.order.get('paymentType') !== this.appConfig.Shared.Order.PaymentType.COD) {
      this.latestOrderLog = await this.conn.fetchLatestOrderConsultationLog(this.order?.id);
      if (!this.latestOrderLog?.stage) return;
      this.isOrderInRefundRelatedStages = this.appConfig.Shared.Order.Stage.orderRefundStages.includes(this.latestOrderLog?.stage);
      if (this.isOrderInRefundRelatedStages && this.latestOrderLog?.stage === this.appConfig.Shared.Order.Stage.REFUND_PROCESSED) {
        this.refundProcessedDate = new Date(this.latestOrderLog.createdAt);
      }
    }
  }

  private getUserLanguagePreference(): void {
    this.isEnglishOrHindiUser = [this.appConfig.Shared.Languages.EN, this.appConfig.Shared.Languages.HI].includes(this.user?.get('languagePreference'));
  }

  setProductApprovalData(): void {
    this.productApprovalDetails = this.order.get('productApprovalDetails')
    this.cancelledProducts = this.orderService.getCancelledProducts(this.order.get('productApprovalDetails'));
    this.shouldShowPartialOrderCancellationUI = this.orderService.shouldShowPartialOrderCancellationUI(this.order);
    this.shouldHideProductDetails = this.orderService.shouldHideProductDetails(this.order, this.cancelledProducts);
  }

  async fetchCancelledProductsCatalogData(): Promise<void> {
    if (!this.cancelledProducts?.length) return;
    const missingIds = this.cancelledProducts
      .map(cp => cp.productObjectId)
      .filter(id => id && !this.products[id]);
    if (!missingIds.length) return;
    const catalogProducts = await this.conn.findCatalogWithKey(missingIds);
    catalogProducts?.forEach((product: any) => {
      this.products[product.id] = product;
    });
  }

  async setRefundDetailsForOrder(): Promise<void> {
    if (this.order.get('paymentType') === this.appConfig.Shared.Order.PaymentType.COD) {
      this.refundInfo = { latestRefundDate: null, payments: [], totalRefundAmount: 0 };
      return;
    }
    this.refundInfo = await this.conn.getRefundInfoForOrder(this.order.id);
  }

  async setUserExperiments(): Promise<void> {
    const experiments = await this.conn.findUserActiveExperiments();
    experiments?.forEach((experiment: any): void => {
      if (experiment.key === 'new_cancellation_logic') {
        this.newCancellationLogicExperiment = true;
        this.orderStagesToShowCannotCancelPopup = experiment.variant?.cannotCancelStages;
      } else if (experiment.key === 'add_extra_regimen_products') {
        this.availableFreeProductsFromExperiment = experiment.variant?.availableProducts || [];
      } else if (experiment.key === 'order_page_instructions_reorder') {
        this.orderStatusBannerExp = true;
      }
    });
  }

  handleProductApprovalDetailsVoiceNote(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'partial_order_cancellation_voice_note', orderId: this.order?.id, stage: this.order?.get('stage') }));
  }

  get doctorImageUrl(): string {
    return this.doctor?.get('doctorDisplayImage') || this.doctor?.get('DoctorImageThumbnail') || 'https://storage.googleapis.com/heallo-other-user-files/doctor_api_charu_07302024_1722317224002.jpg';
  }

  navigateToCart(): void {
    this.conn.navigateToURL('/cart');
  }

  isCancelledProduct(product: any): boolean {
    return this.cancelledProducts?.some(cp => cp.productObjectId === product.id) || false;
  }

  getProductSizeLabel(product: any): string {
    const catalogProduct = this.products[product.id];
    if (!catalogProduct) return '';
    const qty = catalogProduct.get('quantity') || '';
    const unit = catalogProduct.get('quantityUnit') || '';
    const unitStr = typeof unit === 'object' ? (unit?.en || '') : unit;
    if (!qty && !unitStr) return '';
    return `${qty} ${unitStr}`.trim();
  }

  handleProductCardClick(product: any): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'product_card_order_page' }));
    if (this.isBlockedForUnpaidAcquisitionProduct()) return;
    this.conn.navigateToURL(`/product/${product.id}`);
  }

  handleKnowHowToUse(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'instructions_order_page' }));
    if (this.isRegimenOrder && this.regimen) {
      this.navigateToRegimenPage();
    } else {
      this.seeInstructions();
    }
  }

  openMoneyBackGuaranteeBottomSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'MBG_know_more_order_details' }));
    this.bottomSheet.open(MoneyBackGuaranteeBottomsheetComponent, {
      data: {}
    });
  }
}
